<template>
    <v-sheet width="100%" color="content" class="pa-4">
        <v-layout align-center>
            <v-btn class="white green--text" @click="$refs.file.$refs.input.click()"><v-icon left size="20">{{ mdiMicrosoftExcel }}</v-icon>핀 번호 검색</v-btn>
            <span class="caption primary--text ml-4 mt-1">* 첫번째줄은 건너뛰고, 두번째 줄부터 입력됩니다</span>
            <v-spacer/>
            <v-btn class="white blue--text ml-2" @click="pnos = []; input();">
                <v-icon left size="20">{{ mdiRefresh }}</v-icon>
                <span>초기화</span>
            </v-btn>
        </v-layout>
        
        <v-responsive>
            <v-chip v-for="pno, index in pnos" :key="index" close color="secondary" class="mt-4 mr-2" @click:close="pnos.splice(index, 1); input();">{{ pno }}</v-chip>
        </v-responsive>

        <v-file-input ref="file" class="d-none" accept=".xlsx" @change="upload"/>
    </v-sheet>
</template>

<script>
import { mdiMicrosoftExcel, mdiRefresh } from "@mdi/js";
import XLSX from "xlsx";
export default {
    props: ["value"],
    data(){
        return {
            mdiMicrosoftExcel,
            mdiRefresh,

            pnos: [],
        }
    },
    methods: {
        input(){
            this.$emit("input", this.pnos);
        },
        upload(file){
            if(!file) return;
            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach(sheetName => {
                    let sheet = XLSX.utils.sheet_to_json(
                        workBook.Sheets[sheetName]
                    );
                    workSheets.push(sheet);
                });

                let workSheet = workSheets[0];
                let pnos = [];
                for(let row of workSheet){
                    let [pno] = Object.values(row);
                    if(pno) pnos.push(pno?.replace?.(/-/g, ''));
                }

                this.pnos = pnos;
                this.input();
            };
            reader.readAsBinaryString(file);
        }
    }
}
</script>